// extracted by mini-css-extract-plugin
export default {"dialog":"FullScreenDragOverlay-module__dialog--lnxuZ","centeredBody":"FullScreenDragOverlay-module__centeredBody--JMSve","text":"FullScreenDragOverlay-module__text--KmKSn"};